import { useRef } from 'react'
import { Mtds } from 'prove-common'

type AddNewsImageProps = {
  image?: File
  onChange: (image: File | undefined) => void
  disabled?: boolean
  error?: string
}

export const AddNewsImage = ({
  image,
  onChange,
  disabled,
  error
}: AddNewsImageProps) => {
  const inputRef = useRef<HTMLInputElement>(null)
  return (
    <Mtds.Grid>
      <Mtds.Field
        as='input'
        ref={inputRef}
        id='news-image'
        label='Bilde (valgfritt)'
        description='Velg en PNG-fil. Bildet lastes opp når du lagrer og erstatter et eventuelt eksisterende bilde.'
        type='file'
        accept='image/png,.png'
        disabled={disabled}
        validation={error}
        aria-invalid={!!error}
        onChange={(event) => onChange(event.target.files?.[0])}
      />
      {image && (
        <Mtds.Flex data-align='center'>
          <Mtds.Info>
            <strong>Valgt bilde</strong>
            {image.name}
          </Mtds.Info>
          <Mtds.Button
            type='button'
            disabled={disabled}
            onClick={() => {
              onChange(undefined)
              if (inputRef.current) inputRef.current.value = ''
            }}
          >
            Fjern valgt bilde
          </Mtds.Button>
        </Mtds.Flex>
      )}
    </Mtds.Grid>
  )
}
